import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import { AnswerID } from '@aytm/app/swidget/base/questions/types'
import { getMediumAssetPath } from '@aytm/lib/common/assets'
import { IEcommerceAnswerSchema, IEcommerceQuestionSchema } from '../../types.ts'
import ProductCard from './ProductCard.tsx'
import style from './BannerAd.module.scss'

interface IBannerAdProps {
  schema: IEcommerceQuestionSchema
  bannerProducts: IEcommerceAnswerSchema[]
  amountById: Map<AnswerID, number>
  findability: boolean
  onItemSelect: (id: AnswerID) => void
  onAddToCart: (id: AnswerID, qnt: number) => void
}

const BannerAd = ({ schema, bannerProducts, amountById, findability, onItemSelect, onAddToCart }: IBannerAdProps) => {
  const viewport = useViewport()

  return (
    <section className={`${style.banner} ${viewport.mobile ? style.bannerMobile : ''}`} data-testid="SW-EC-Banner">
      {schema.ad_company_description && <p className={style.description}>{schema.ad_company_description}</p>}

      <div className={style.row}>
        {schema.ad_image2 && (
          <img src={getMediumAssetPath(schema.ad_image2)} alt="" role="presentation" className={style.adImage} />
        )}
        {bannerProducts.map(answer => (
          <div key={answer.id} className={style.item}>
            <ProductCard
              data-testid="SW-EC-BannerItem"
              schema={schema}
              answer={answer}
              amount={amountById.get(answer.id) ?? 0}
              findability={findability}
              compact
              saveToList={false}
              disabled={false} // corpus rule: the ad placement sits outside the focus-mode gate (widget.md §Promo Banners)
              onSelect={() => onItemSelect(answer.id)}
              onAdd={qnt => onAddToCart(answer.id, qnt)}
            />
          </div>
        ))}
      </div>
    </section>
  )
}

export default BannerAd
